import * as types from './subscription-access.types';
import * as constants from './subscription-access.constants';

export const storeSubscriptionAccess = (access: types.ISubscriptionAccess): types.IStoreSubscriptionAccess => ({
  type: constants.STORE_SUBSCRIPTION_ACCESS,
  payload: access,
});

export const clearSubscriptionAccess = (): types.IClearSubscriptionAccess => ({
  type: constants.CLEAR_SUBSCRIPTION_ACCESS,
});
